import { __awaiter } from "tslib";
import "../Polyfills/Fetch";
import * as TmsConstants from "./TargetedMessagingConstants";
import * as Utils from "../Utils";
const {
  isNOU
} = Utils;
export class TargetedMessagingTransport {
  constructor(sessionId) {
    this.sessionId = sessionId;
  }
  sendGetRequest(requestUrl, token, useTimeout, timeout) {
    return __awaiter(this, void 0, void 0, function* () {
      const requestInit = {
        method: "GET",
        headers: this.createHeaders(token)
      };
      return useTimeout ? this.timeoutFetch(requestUrl, requestInit, timeout !== null && timeout !== void 0 ? timeout : TmsConstants.TMS_FETCH_TIMEOUT) : fetch(requestUrl, requestInit);
    });
  }
  sendPostRequest(requestUrl, requestBody, token, useTimeout, timeout) {
    return __awaiter(this, void 0, void 0, function* () {
      const requestInit = {
        method: "POST",
        headers: this.createHeaders(token),
        body: requestBody
      };
      return useTimeout ? this.timeoutFetch(requestUrl, requestInit, timeout !== null && timeout !== void 0 ? timeout : TmsConstants.TMS_FETCH_TIMEOUT) : fetch(requestUrl, requestInit);
    });
  }
  createHeaders(token) {
    const headers = typeof Headers !== "undefined" && new Headers();
    if (headers) {
      if (!isNOU(token)) {
        headers.append("Authorization", "Bearer " + token);
      }
      headers.append("X-CorrelationId", Utils.guid());
      if (this.sessionId) {
        headers.append("X-UserSessionId", this.sessionId);
      }
    }
    return headers;
  }
  timeoutFetch(input) {
    let init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let timeout = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise((resolve, reject) => {
      fetch(input, init).then(resolve, reject);
      setTimeout(() => reject(new Error("Service request timed out")), timeout);
    });
  }
}